import React, { useContext, useState, useEffect } from 'react';
import h from '../../../helpers/common';
import { __ } from '../../../translations';
import { EVENT } from '../../../contexts/MixpanelConstants';
import { getMixpanelErrorCodeProperty } from '../../../contexts/MixpanelHelper';
import { MixpanelContext } from '../../../contexts/MixpanelContext';
import { Error, Button } from '@intigral/shared';

export const PlayerError = (props) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [source, setSource] = useState('');
    const [exception, setException] = useState('');
    const [responseCode, setResponseCode] = useState('');
    const [type, setType] = useState('');
    const [status, setStatus] = useState('');
    const [uiDisplay, setUiDisplay] = useState(true);
    const { track } = useContext(MixpanelContext);
    const [isLoading, setIsLoading] = useState(false);
    let key = '',
        translatedVal = '';
    if (exception) {
        key = `video-error-${exception.toLowerCase()}`;
        translatedVal = __(key) || '';
        translatedVal = translatedVal.replace('{errorCode}', responseCode);
    }
    if (status && !source) {
        track(
            h.getScreen() + ' - ' + EVENT.LIVE_TV.ERROR_POPUP,
            getMixpanelErrorCodeProperty(responseCode || description)
        );
    }

    if (status && source === 'VOD') {
        track(
            h.getScreen() + ' - ' + EVENT.VOD_PLAYER.ERROR_POPUP,
            getMixpanelErrorCodeProperty(responseCode || description)
        );
    }
    useEffect(() => {
        setTitle(props.error?.title);
        setDescription(props.error?.description);
        setSource(props.error?.source);
        setException(props.error?.exception);
        setResponseCode(props.error?.responseCode);
        setType(props.error?.type);
        setStatus(props.error?.status);
        if (!props.error?.title && !props.error?.description) {
            setUiDisplay(false);
        } else {
            setUiDisplay(true);
        }
    }, [props.error]);

    const onErrorHandler = async () => {
        try {
            setIsLoading(true);
            const {
                onClickHandler = () => {
                    return;
                },
            } = props.error;
            await onClickHandler();
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {status && title != null && (
                <Error
                    absolute
                    icon={type === 'warn' ? 'screen' : 'alert'}
                    iconColor={type === 'warn' ? 'green' : 'red'}
                    errorPairs={[{ title: title, text: key ? translatedVal : description }]}
                >
                    {props.error?.onClickHandler && (
                        <Button primary compact onClick={onErrorHandler} loading={isLoading}>
                            {__('refresh_page')}
                        </Button>
                    )}
                </Error>
            )}
        </>
    );
};
